module.exports = __webpack_public_path__ + "media/toolkits/toolkits-analytics-small-01cee499.png";